// extracted by mini-css-extract-plugin
export default {"nav":"HeaderFooterMenu_nav__PdujJ","menu":"HeaderFooterMenu_menu__IMi6t"};